<template>
  <div class="app-content">
    <AppPageTitle></AppPageTitle>
    <Content class="app-content__main">
      <Form :label-width="110">
        <FormItem label="选择供应商">
          <Select
            v-model="supplierId"
            style="width:200px;"
            placeholder="请选择或输入查询"
            @on-change="suppliersChange"
            filterable
            clearable>
            <Option v-for="item in suppliers" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
          <Button
            style="margin-left: 24px;"
            :disabled="!supplierId"
            type="primary"
            icon="md-add"
            @click="createItem"
          >新增供应商商品</Button>
        </FormItem>
        <FormItem label="商品名称:" prop="commodityName" :label-width="110">
          <Input v-model.trim="queryForm.supplierCommodityName" placeholder="请输入" clearable maxlength="50" style="width: 200px" />
          <Button
            style="margin-left: 24px;"
            type="primary"
            icon="md-search"
            @click="getData"
          >搜索</Button>
        </FormItem>
      </Form>
      <Table
        :columns="queryColumn"
        :loading="loading"
        :data="queryData"
        row-key="id"
        border
        ref="dataTable"
        :load-data="handleLoadData"
      >
        <template slot-scope="{row, index}" slot="action">
          <Button
            type="text"
            class="text-link"
            size="small"
            icon="md-create"
            @click="updateItem(row, index)"
          >编辑</Button>
          <Button
            type="text"
            class="text-link"
            size="small"
            icon="md-trash"
            @click="deleteItem(row)"
          >删除</Button>
        </template>
      </Table>
      <Row>
        <Col :md="24" class="pagination">
          <Page
            :total="totalPage"
            :page-size="pageSize"
            :current="pageNum"
            :disabled="loading"
            @on-change="pageChange"
            @on-page-size-change="pageSizeChange"
            show-elevator show-sizer show-total />
        </Col>
      </Row>
    </Content>
    <SupplierCommodityCreateUpdate :default-supplier-id="supplierId" ref="SupplierCommodityCreateUpdate" @success="createUpdateSuccess" />
  </div>
</template>

<script>
import _ from 'underscore'
import api from '../../api'
import SupplierCommodityCreateUpdate from '@/components/supplier/SupplierCommodityCreateUpdate.vue'
// import SelectAgent from '../../components/agent/selectAgent'

export default {
  components: {
    SupplierCommodityCreateUpdate
    // SelectAgent
  },
  data () {
    return {
      queryForm: {
        supplierCommodityName: ''
      },
      suppliers: [],
      supplierId: '',
      queryData: [],
      loading: false,
      totalPage: 1,
      pageSize: 10,
      pageNum: 1,
      queryCommodity: null
    }
  },
  computed: {
    queryColumn () {
      return [
        {
          title: '商品编号',
          key: 'id',
          align: 'center',
          minWidth: 150
        },
        {
          title: '商品标识',
          key: 'supplierCommodityNo',
          align: 'center',
          minWidth: 150
        },
        {
          title: '商品名称',
          key: 'supplierCommodityName',
          align: 'center',
          minWidth: 150
        },
        {
          title: '商品类型',
          key: 'couponType',
          align: 'center',
          minWidth: 150,
          render: (h, params) => {
            return h('span', {style: {color: params.row.couponType === 2 ? '#2db7f5' : '#808695'}}, params.row.couponType === 2 ? '券包' : '单券')
          }
        },
        {
          title: '销售价(元)',
          key: 'costPrice',
          minWidth: 130,
          align: 'center'
        },
        {
          title: '销售折扣(%)',
          key: 'costDiscount',
          minWidth: 130,
          align: 'center'
        },
        {
          title: '税点',
          key: 'taxPoint',
          minWidth: 130,
          align: 'center'
        },
        {
          title: '操作',
          key: 'id',
          minWidth: 150,
          slot: 'action',
          align: 'center'
        }
      ]
    },
    currentSupplierInfo () {
      return _.find(this.suppliers, item => {
        return item.id === this.supplierId
      })
    }
  },
  methods: {
    handleLoadData (item, callback) {
      setTimeout(() => {
        const data = [
          {
            id: '10100',
            name: 'John Brown',
            age: 18,
            address: 'New York No. 1 Lake Park'
          },
          {
            id: '10101',
            name: 'Joe Blackn',
            age: 30,
            address: 'Sydney No. 1 Lake Park'
          }
        ];
        callback(data);
      }, 2000);
    },
    getSuppliers () {
      api.supplier.supplierList({
        pageNum: 1,
        pageSize: 999
      }).then(res => {
        this.suppliers = res.data.records || []
      }).catch(err => {
        this.$Message.error(err.message || '获取供应商列表失败，请刷新重试！')
      })
    },
    getData () {
      this.loading = true
      if (this.supplierId) {
        api.commodity.commodityList({
          ...this.queryForm,
          supplierId: this.supplierId,
          sourceType: 1,
          useState: 1,
          pageNum: this.pageNum,
          pageSize: this.pageSize
        })
          .then((res) => {
            this.loading = false
            this.totalPage = +res.data.total
            let items = res.data.records || []
            for (let i = 0; i < items.length; i++) {
              if (items[i].couponType === 2) {
                items[i].children = []
                items[i]._loading = false
              }
            }
            this.queryData = items
            console.log(items)
          })
          .catch((err) => {
            this.loading = false
            this.$Message.error('获取供应商列表失败: ' + err.message)
          })
      } else {
        this.pageNum = 1
        this.pageSize = 10
        this.totalPage = 0
        this.queryData = []
        this.loading = false
      }
    },
    suppliersChange () {
      this.pageNum = 1
      this.getData()
    },
    pageChange (pageNum) {
      this.pageNum = pageNum
      this.getData()
    },
    pageSizeChange (pageSize) {
      this.pageSize = pageSize
      this.pageNum === 1 ? this.getData() : this.pageNum = 1
    },
    // 新增
    createItem () {
      this.$refs.SupplierCommodityCreateUpdate.show('create', this.currentSupplierInfo || {})
    },
    // 编辑
    updateItem (row, index) {
      this.$refs.SupplierCommodityCreateUpdate.show('update', row, index)
    },
    // 删除
    deleteItem (row) {
      this.$Modal.confirm({
        title: '删除确认',
        content: `<p>您确定删除此代理的商品吗？</p>
                  <p><small class="text-danger">注：删除后，供应商对此产品的所有代理请求将会被拒绝。</small></p>`,
        loading: true,
        onOk: () => {
          api.commodity.commodityUpDown({
            commodityId: row.id,
            useState: 0,
            sourceType: 1
          })
            .then(() => {
              this.$Modal.remove()
              if (!(this.queryData.length - 1)) {
                this.pageNum = this.pageNum - 1 ? this.pageNum - 1 : 1
              }
              this.getData()
              this.$Message.success(`删除成功!`)
            })
            .catch((err) => {
              this.$Modal.remove()
              setTimeout(() => {
                this.$Modal.error({
                  title: '抱歉',
                  content: `删除失败: ` + err.message
                })
              }, 400)
            })
        }
      })
    },
    // 新增，编辑成功
    createUpdateSuccess () {
      this.getData()
    }
  },
  created () {
    this.getSuppliers()
  }
}
</script>
